import React, { useEffect, useState } from "react";
import BackButton from "../bars/BackButton";
import Ticket from "./components/Ticket";
import { fetch_event_history } from "../../actions/events/event";
import { validateTicket } from "../../utils/util";
import { useLocation } from "react-router-dom";
import Skeleton from "../../components/skeletons/skeleton";
import Emty from "../../components/emty-state/Emty";
import { TicketsPageView } from "../../utils/Analytics";



function TicketsList() {
  const [historylist, setHistoryList] = useState([])
  const [error, setError] = useState("")
  const appUserId = localStorage.getItem("appUserId");
  const location = useLocation();
  const [loading,setLoading] = useState(false);
  const sortList = (events)=>{
   return events.sort((a, b) => new Date(b.id) - new Date(a.id));
  }

  useEffect(() => {
    const handlePopState = () => {
      // Perform redirect if coming from ticket page
       // window.location.href = redirectUrl;
        console.log("object")
    
    };

    // Add event listener for back navigation
    window.addEventListener("popstate", handlePopState());

    // Clean up the event listener on component unmount
   
  }, []);

  const fetchHistory = async()=>{
    setLoading(true);
    try{
      const res = await fetch_event_history(appUserId)
       if(res?.data?.success){
        if(res?.data?.data?.length){
          setHistoryList(sortList(res?.data?.data))
          
        }else{
          setError("No event bookings found")  
        }
      }
      setLoading(false);
    }
    catch(e){
      console.log(e)
      setLoading(false);
    }
  }
  
  useEffect(()=>{
    TicketsPageView();
    fetchHistory()
   },[])

   
  return (
    <div>
      {!loading ? (
        <div>

    <div className="pt-4 min-h-screen relative event-data section-wrap">
      <div className=" flex items-center gap-3 mb-3">
        <BackButton link="../"/>
        <div className="event-heading">My Tickets</div>
      </div>
     {historylist?.length ? <div className="flex flex-col gap-8 mt-8 pb-8">
       {historylist?.map((item, i)=>{
        return <Ticket key={i} data={item} active={validateTicket(item?.bookedForDate)} payment_status={item?.payment_status}/>
       })}
      </div>: <Emty item="Tickets" />}
      <div className="text-center mt-32">{error}</div>
    </div>
    </div>
      ) : (
        <Skeleton type="page" />
      )}
    </div>
  );
}

export default TicketsList;
